import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { WebPopService, State } from '../services';

export const webInternal = (webPop: WebPopService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (!state.system?.webInternal)
        return of([state, currentState] as [Partial<State>, State]);

      const tabs = state.system.webInternal;
      tabs.forEach((tab) =>
        webPop.openInternal(tab.url, tab.title, tab.additionalVars)
      );
      return of([
        {
          ...state,
          ...{
            system: {
              ...state.system,
              webInternal: undefined,
            },
          },
        },
        currentState,
      ] as [Partial<State>, State]);
    })
  );
